<template>
  <div class="login-wrap">
    <h2>
      <img :src="logoUrl" alt="" class="logo-img" />
      <span>{{ sysName }}</span>
    </h2>
    <a-form :form="form" class="login-form" @submit="handleSubmit">
      <a-form-item>
        <a-input
          size="large"
          v-decorator="$decorator('username', '管理员ID不能为空')"
          placeholder="管理员ID"
        >
          <a-icon slot="prefix" type="user" class="icon-color" />
        </a-input>
      </a-form-item>
      <a-form-item>
        <a-input-password
          size="large"
          v-decorator="$decorator('password', '管理员密码不能为空')"
          placeholder="管理员密码"
        >
          <a-icon slot="prefix" type="lock" class="icon-color" />
        </a-input-password>
      </a-form-item>
      <a-form-item>
        <a-input
          :maxLength="5"
          class="img-input"
          size="large"
          v-decorator="$decorator('captcha', '图片验证码不能为空')"
          placeholder="图片验证码"
        >
          <a-icon slot="prefix" type="key" class="icon-color" />
        </a-input>
        <img
          :src="imgCodeUrl"
          alt="图片验证码"
          class="img_code"
          @click="getImgCodeUrl"
        />
      </a-form-item>
      <div class="text-div">
        <a-button type="link" size="small" @click="$router.push('/reset-psw')">
          忘记密码
        </a-button>
      </div>
      <a-form-item>
        <a-button
          :loading="loading"
          type="primary"
          html-type="submit"
          block
          size="large"
        >
          登录
        </a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { userImgCode } from 'api/verificationCode'
import { login, queryTitle } from './api'
import { mapMutations, mapGetters } from 'vuex'
import { SET_USER_INFO, SET_MENUS } from 'config/mutation-types/user'
import { SET_SYS_NAME } from 'config/mutation-types/app'

export default {
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      imgCodeUrl: '',
      loading: false,
    }
  },
  mounted() {
    this.getImgCodeUrl()
    this.getTitle()
  },
  computed: {
    ...mapGetters('app', ['logoUrl', 'sysName']),
  },
  methods: {
    ...mapMutations('user', [SET_USER_INFO, SET_MENUS]),
    ...mapMutations('app', [SET_SYS_NAME]),

    async getTitle() {
      try {
        const stamp = new Date().getTime()
        const { data } = await queryTitle(stamp)
        this[SET_SYS_NAME](data)
      } catch (error) {
        console.error(error)
      }
    },

    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.loading = true
          try {
            const {
              data: { token, menus },
            } = await login(values)

            this[SET_USER_INFO]({
              token,
              username: values.username,
            })
            this[SET_MENUS](menus)

            const redirectName = this.$route.query.redirect || 'personal'

            await this.$router.push({
              name: redirectName,
            })
          } catch (e) {
            this.form.setFieldsValue({ captcha: '' })
            this.getImgCodeUrl()
          }
          this.loading = false
        }
      })
    },
    getImgCodeUrl() {
      this.imgCodeUrl = userImgCode()
    },
  },
}
</script>

<style scoped lang="less">
.login-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background: url('./img/bg.png') no-repeat #1890ff;
  background-size: 100%;

  /deep/ .ant-input {
    border-radius: 0;
  }

  /deep/ .ant-btn-lg {
    border-radius: 0;
  }

  h2 {
    text-align: center;
    font-size: 44px;
    color: #fff;
    font-weight: bold;
    text-shadow: 0 0 #949697, 0 0 #949697, 1px 0 #949697, 0 2px #949697;
    letter-spacing: 2px;

    img {
      width: 88px;
    }

    span {
      margin-left: 25px;
    }
  }
  .login-form {
    position: relative;
    width: 340px;
    height: 296px;
    background: #fff;
    padding: 30px;
    box-sizing: border-box;
  }

  .img-input {
    width: 160px;
  }

  .img_code {
    margin-left: 10px;
  }

  .icon-color {
    color: rgba(0, 0, 0, 0.25);
  }

  .text-div {
    text-align: right;
    margin-top: -12px;
    margin-bottom: 10px;
  }
}
</style>
